import { api } from './client';
import {
  CreateTagRequest,
  PagedResponseTagItemDto,
  ResolveTagsRequest,
  ResolveTagsResponse,
  TagItemDto
} from './types';

export interface SearchTagsQuery {
  q?: string;
  page?: number;
  limit?: number;
}

export const searchTags = async (query: SearchTagsQuery): Promise<PagedResponseTagItemDto> => {
  const { data } = await api.get<PagedResponseTagItemDto>('/admin/tags', { params: query });
  return data;
};

export const createTag = async (payload: CreateTagRequest): Promise<TagItemDto> => {
  const { data } = await api.post<TagItemDto>('/admin/tags', payload);
  return data;
};

export const resolveTags = async (payload: ResolveTagsRequest): Promise<ResolveTagsResponse> => {
  const { data } = await api.post<ResolveTagsResponse>('/admin/tags/resolve', payload);
  return data;
};

export const suggestTags = async (q: string, limit = 10): Promise<TagItemDto[]> => {
  const { data } = await api.get<TagItemDto[]>('/admin/tags/suggest', { params: { q, limit } });
  return data;
};
